// src/AuthContext.js
// เก็บสถานะผู้ใช้ / token ใช้ร่วมกันทั้งแอป

import React, { createContext, useEffect, useState } from "react";

import api from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });

  const [token, setToken] = useState(() => {
    return localStorage.getItem("token") || null;
  });

  // sync user กับ localStorage
  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
    }
  }, [user]);

  // sync token กับ localStorage
  useEffect(() => {
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }
  }, [token]);

  // Sync user profile & permissions latest state from backend
  useEffect(() => {
    if (!token) return;
    api.get("/auth/me")
      .then((res) => {
        if (res.data) {
          setUser((prev) => {
            if (!prev) return res.data;
            return { ...prev, ...res.data };
          });
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          logout();
        }
      });
  }, [token]);

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  };

  return (
    <AuthContext.Provider
      value={{ user, token, setUser, setToken, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
